module.exports = __webpack_public_path__ + "img/tc-logo.a023ba9f.png";